import clsx from 'clsx';
import { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AlertIcon from '@material-ui/icons/ErrorOutline';
import DoneIcon from '@material-ui/icons/CheckCircle';
import LoadingIcon from '@material-ui/core/CircularProgress';
import Typography from 'components/CncUI/Typography';
import Radio from 'components/CncUI/Radio';
import UploadButton from 'components/UploadButton';

const useStyles = makeStyles(({ palette }) => ({
  icon: {
    lineHeight: '40px',
    verticalAlign: 'middle',
    marginLeft: 16,
  },
  alert: {
    color: palette.cncUI.alert.red.primary,
  },
  done: {
    color: palette.cncUI.alert.green.primary,
  },
  loading: {
    color: palette.cncUI.default.primary,
  },
}));

const UploadVerification = props => {
  const {
    id = 'UploadVerification',
    disabled,
    loading,
    onChange,
    value,
    single,
    isCanada,
  } = props;
  const { title, accept, children } = props;
  const [type, setType] = useState(
    (isCanada && 'Articles of Incorporation') || '',
  );
  const classes = useStyles();
  const label = title
    ? title
    : single
    ? 'IRS acceptance letter *'
    : 'Supporting Document *';

  useEffect(() => {
    setType((isCanada && 'Articles of Incorporation') || '');
  }, [single]);

  const save = args => {
    if (onChange) {
      onChange(args, type);
    }
  };

  return (
    <>
      <Typography body1 long style={{ marginBottom: 2 }}>
        {label}
      </Typography>
      {!single && (
        <Radio.Group value={type} onChange={e => setType(e.target.value)}>
          <Radio value="IRS acceptance letter">IRS acceptance letter</Radio>
          <Radio value="Redacted 1065 form">Redacted 1065 form</Radio>
          <Radio value="Partnership agreement">Partnership agreement</Radio>
        </Radio.Group>
      )}
      <UploadButton
        id={id}
        secondary
        disabled={disabled}
        loading={loading}
        accept={accept || '.pdf,.png,.jpg,.jpeg'}
        onChange={save}
      >
        {children}
      </UploadButton>
      {!disabled && !value && !loading && (
        <AlertIcon
          className={clsx(classes.icon, classes.alert)}
          id={`${id}-AlertIcon`}
        />
      )}
      {!disabled && loading && (
        <LoadingIcon
          size={20}
          thickness={5}
          className={clsx(classes.icon, classes.loading)}
        />
      )}
      {!disabled && value && !loading && (
        <DoneIcon
          className={clsx(classes.icon, classes.done)}
          id={`${id}-DoneIcon`}
        />
      )}
    </>
  );
};

export default UploadVerification;
